import { UserState } from '../enums/user-state.enum';

export interface IUser {
    id: string;
    organization: string;
    email: string;
    state: UserState;
    active: string;
    createdAt: Date;
    roles: string[];
    organizationRole: string;
}
